import gql from 'graphql-tag';

export const DynamicPricingQuery = gql`
	query RecommendPurchasingStandardDuringPremiumEot_DynamicPricingQuery(
		$cloudId: ID!
		$productKey: String!
	) {
		tenantContexts(cloudIds: [$cloudId]) {
			entitlementInfo(hamsProductKey: $productKey) {
				entitlement {
					... on CcpEntitlement {
						defaultOfferingTransitions(offeringName: "Standard") {
							listPriceForOrderWithDefaults {
								averageAmountPerUnit
								item {
									chargeElement
								}
							}
						}
						subscription {
							trial {
								listPriceEstimates {
									averageAmountPerUnit
									item {
										chargeElement
									}
								}
							}
						}
					}
				}
			}
		}
	}
`;
